import type { Edge } from '../../core';
import type { MindmapState } from '../types';

/** State after a new `edges` array; the lookup lets edges and handles find each other by id. */
export const withEdges = (edges: Edge[]): Pick<MindmapState, 'edges' | 'edgeLookup'> => ({
  edges,
  edgeLookup: new Map(edges.map((edge) => [edge.id, edge])),
});
